import React from 'react';
import { Card, CardBody, Col, Container, Row } from 'reactstrap';
import { Breadcrumbs } from '../../../../AbstractElements';
import { DateTimePicker } from '../../../../Constant';
import HeaderCard from '../../../Common/HeaderCard';
import DateTimeForm from './DateTimeForm';

const DateTimeContain = () => {
  return (
    <Container fluid={true}>
      <Breadcrumbs pageTitle={DateTimePicker} parent='Form Widgets' title={DateTimePicker} />
      <Card>
        <HeaderCard title={DateTimePicker} />
        <CardBody>
          <Row>
            <Col md='12'>
              <div className='datetime-picker'>
                <DateTimeForm />
              </div>
            </Col>
          </Row>
        </CardBody>
      </Card>
    </Container>
  );
};
export default DateTimeContain;
